<template>
  <div class="inv-row">
    <div class="inv-avatar">
      <f7-icon :f7="invitation.channel === 'INVITE_LINK' ? 'link' : 'envelope_fill'" size="16" />
    </div>
    <div class="inv-info">
      <div class="inv-name">{{ invitation.name || invitation.phoneOrEmail }}</div>
      <div class="inv-meta">
       {{ $t('common.invitationSent', { sentAt: relativeDate(invitation.sentAt), channel: channelLabel(invitation.channel) }) }} 
      </div>
    </div>

    <f7-button
      v-if="mode === 'sent'"
      small outline round
      @click="$emit('resend', invitation)"
    >
      {{$t('payout.nudge')}}
    </f7-button>

    <div v-else class="inv-actions">
      <f7-button small round @click="$emit('accept', invitation)">{{$t('common.accept')}}</f7-button>
      <f7-button small outline round color="red" @click="$emit('decline', invitation)">{{$t('common.decline')}}</f7-button>
    </div>
  </div>
</template>

<script setup>

import i18n from '../../js/i18n'
defineProps({
  invitation: { type: Object, required: true },
  mode: { type: String, default: 'sent' },
})
defineEmits(['resend', 'accept', 'decline'])

const channelLabels = {
  INVITE_LINK: i18n.global.t('common.link'), DIRECT_MESSAGE: i18n.global.t('common.directMessage'), DIRECT_INVITE: i18n.global.t('common.directInvite'),
  WHATSAPP: 'WhatsApp', SMS: 'SMS', EMAIL: i18n.global.t('common.email'),
}
function channelLabel(c) { return channelLabels[c] || c }

function relativeDate(iso) {
  const days = Math.floor((Date.now() - new Date(iso)) / 86400000)
  if (days === 0) return i18n.global.t('common.today')
  if (days === 1) return i18n.global.t('common.yesterday')
  return i18n.global.t('common.daysAgo', { count: days })
}
</script>

<style scoped>
.inv-row {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 4px; border-bottom: 1px solid var(--f7-list-item-border-color, #e0e0e0);
}
.inv-row:last-child { border-bottom: none; }
.inv-avatar {
  width: 36px; height: 36px; border-radius: 50%;
  background: var(--f7-list-bg-color, #f5f5f5);
  display: flex; align-items: center; justify-content: center;
  color: var(--f7-on-surface-variant, #8e8e93); flex-shrink: 0;
}
.inv-info { flex: 1; min-width: 0; }
.inv-name { font-size: 13px; font-weight: 500; }
.inv-meta { font-size: 11px; color: var(--f7-on-surface-variant, #8e8e93); margin-top: 1px; }
.inv-actions { display: flex; gap: 6px; flex-shrink: 0; }
</style>
